// ! TODO: Implement general position
export enum LabelPosition {
  Left = 'left',
  Right = 'right',
}
